// extracted by mini-css-extract-plugin
export default {"savedSearchesButton":"savedSearchesButton__ZDU2O","button":"button__ZTU4N","searches":"searches__YzgzN"};